class CartQueue {
  constructor() {
    this.items = [];
    this.blocked = false;
  }
  enqueue(item) {
    this.items.push(item);
    this.#run();
    return item;
  }
  #run() {
    if(this.blocked) {
      return;
    }
    this.blocked = true;
    const item = this.items.shift();
    fetch(item.url, item.options)
    .then((response) => {
      this.blocked = false;
      if(this.items.length > 0){
        this.#run();
      }
      return response.json();
    })
    .then((response) => {
      if (response.status === 422) {
        const error_string = `\nCART API CALL FAILED \nStatus: ${response.status} \nMessage: ${response.message} \nDescription: ${response.description}`;
        throw new Error(error_string, { cause: "Cart Error" });
      } else {
        item.callback(response);
      }
    })
    .catch((error) => {
      item.error(error);
    });
  }
}
window.Shopify = window.Shopify || {}
window.Shopify.cartQueue = new CartQueue();